import React from "react";

function StudentFeeDetails() {
  const data = {
    studentName: "Ravi",
    className: "10-A",
    total: 11500,
    paid: 7000,
    pending: 4500,
    transactions: [
      { date: "01 Jan", type: "Admission", amount: 2000 },
      { date: "05 Jan", type: "Tuition", amount: 3000 },
      { date: "10 Jan", type: "Tuition", amount: 2000 }
    ]
  };

  return (
    <div>
     {data && (
            <div className="p-6 bg-gray-100 min-h-screen">

            {/* 🔹 Header */}
            <div className="bg-white rounded-xl shadow p-4 mb-6 flex justify-between">
                <div>
                <h2 className="text-xl font-bold">{data.studentName}</h2>
                <p className="text-blue-600 font-bold">Class: {data.className}</p>
                </div>
            </div>

            {/* 🔹 Section 1: Fee Summary */}
            <div className="bg-white rounded-xl shadow p-6 mb-6">
                <h3 className="text-lg font-semibold mb-4">Fees Details</h3>

                <div className="grid grid-cols-1">
                 <p className="text-blue-600">Total Amount: ₹{data.total}</p>
                 <p className="text-green-600">Paid : ₹{data.paid}</p>
                 <p className="text-yellow-600">Discount : ₹{data.discount?data.discount:0}</p>
                 <p className="text-red-600">Pending : ₹{data.pending}</p>
                 <p className="text-gray-600">books Fee : ₹{data.discount?data.discount:0}</p>

               
                </div>
            </div>

            {/* 🔹 Section 2: Transactions */}
            <div className="bg-white rounded-xl shadow p-6">
                <h3 className="text-lg font-semibold mb-4">Payment Transactions</h3>

                <table className="w-full text-left border">
                <thead className="bg-gray-100">
                    <tr>
                    <th className="p-2 border">Date</th>
                    <th className="p-2 border">Type</th>
                    <th className="p-2 border">Amount</th>
                    </tr>
                </thead>

                <tbody>
                    {data.transactions.map((txn, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                        <td className="p-2 border">{txn.date}</td>
                        <td className="p-2 border">{txn.type}</td>
                        <td className="p-2 border">₹{txn.amount}</td>
                    </tr>
                    ))}
                </tbody>
                </table>
            </div>

            </div>
      )}
      </div>
  );
}

export default StudentFeeDetails;